/**
 * Created by anatoly on 22.04.2024
 */

const TapToSkip = TapToContinue.extend({
    ctor: function (options) {
        this._super(options);

        this.clickHandler = cleverapps.UI.onClick(this, () => {
        }, {
            interactiveScale: false,
            onOuterTouch: cleverapps.once(() => {
                options.onSkip = options.onSkip || function () {};
                options.onSkip();

                this.hide();
            })
        });
    },

    hide: function () {
        if (!this.clickHandler) {
            return;
        }

        this.clickHandler.remove();
        this.clickHandler = undefined;

        this.stopAllActions();

        this.runAction(new cc.FadeOut(0.1)).setFinalize(() => {
            this.removeFromParent();
        });
    }
});

cleverapps.styles.TapToSkip = {
    x: { align: "center" },
    y: { align: "bottom", dy: 50 }
};